// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"ChartEdit_modal_title__QOb81","input_title":"ChartEdit_input_title__6ImKE","button_wrapper":"ChartEdit_button_wrapper__3A9P0"};